<template>
  <div class = "sketch-public-info" v-if="forceshow || project.is_finished === true || (project.owner !== null && project.owner !== undefined && project.owner.id !== $store.state.auth.userid )">
    <h1 v-if="project.is_finished">Proyecto Finalizado</h1>
    <div class = "sketch-data">
      <h2 v-if="projectname">{{projectname}}</h2>
      <h2 v-else>{{project.name}}</h2>
      <p class = "description">{{project.description}}</p>
    </div>

    <div class = "flex">
      <div class = "profile-picture">
        <img v-if="project.owner.picture" :src="project.owner.picture"/>
        <img v-else src="/static/img/student.png" />
      </div>

      <div class = "created-by">
        <p class = "lbl" v-if="project.owner.name">Creado por</p>
        <p v-if = "project.owner.name">{{project.owner.name}}</p>
        <p>
          <a v-if="project.owner.social_link" :href="socialLinkUrl(project.owner.social_link)" target="_blank">
            {{project.owner.social_link}}
          </a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SketchPublicInfo',
  props: {
    project: Object,
    forceshow: {
      type: Boolean,
      default: false
    },
    projectname: {
      type: String,
      default: ''
    }
  },
  methods: {
    socialLinkUrl: function (socialLink) {
      if (!socialLink) return ''
      if (socialLink.charAt(0) === '@') return 'http://twitter.com/' + socialLink
      else if (socialLink.indexOf('http') !== -1) return socialLink
      else return ''
    }
  },
  data: () => ({

  })
}
</script>
<style lang="less">
@import (reference) "../../assets/styles/main.less";

@media (max-width: @breakPoint) {
  .sketch-public-info {
    display: none;
  }
}

.sketch-public-info {
  margin: 30px 0px 0px 0px;
  width: 318px;
  background: white;
  padding: 12px 15px;
  border: 2px solid @redcolor;
  box-shadow: 0 0 2px 0 rgba(0,0,0,.25);
  border-radius: 1px;

  h1 {
    color: @redcolor;
    margin-bottom: 5px;
  }

  .description {
    color: #6c6c6c;
  }

  .flex {
    display: flex;
    padding-top: 15px;
  }

  p {
    font-family: Share Tech,monospace;
  }

  .created-by {
    .lbl {
      text-decoration: underline;
    }
  }

  .profile-picture {
    max-height: 50px;
    max-width: 50px;
    background: white;
    border-radius: 50%;
    padding: 3px;
    margin-right: 12px;
    border: 1px solid #c2c2c299;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UI/SketchPublicInfo.vue